import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const AUTO_DENY_SEC = 30;

/**
 * CC 工具调用权限审批弹窗（设计方案 §7.3 control_request can_use_tool）
 *
 * 显示工具名、参数、描述，学生点击允许/拒绝后发送 control_response。
 * 30 秒无操作自动拒绝（防止 CC 无限等待）。
 *
 * Props:
 *   permission   { request_id, tool_name, tool_input, description }  null 时不显示
 *   onRespond    (allowed: boolean, requestId: string) => void
 */
const CCPermissionDialog = ({ permission, onRespond }) => {
  const [countdown, setCountdown] = useState(AUTO_DENY_SEC);

  useEffect(() => {
    if (!permission) return;
    setCountdown(AUTO_DENY_SEC);
    const timer = setInterval(() => {
      setCountdown((c) => {
        if (c <= 1) {
          clearInterval(timer);
          onRespond(false, permission.request_id);
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [permission, onRespond]);

  if (!permission) return null;

  const inputStr = permission.tool_input
    ? JSON.stringify(permission.tool_input, null, 2)
    : "";

  return (
    <Dialog
      open={!!permission}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { background: "#161b22", color: "#e6edf3", borderRadius: "10px" } }}
    >
      <DialogTitle style={{ borderBottom: "1px solid #30363d", paddingBottom: "12px" }}>
        <span style={{ color: "#d29922", marginRight: "8px" }}>⚠️</span>
        CC 请求使用工具
      </DialogTitle>
      <DialogContent style={{ paddingTop: "16px" }}>
        <div style={{ marginBottom: "10px" }}>
          <span style={{ color: "#8b949e", fontSize: "12px" }}>工具名称</span>
          <div style={{ color: "#58a6ff", fontWeight: 600, fontSize: "15px", marginTop: "2px" }}>
            {permission.tool_name}
          </div>
        </div>
        {permission.description && (
          <div style={{ marginBottom: "10px" }}>
            <span style={{ color: "#8b949e", fontSize: "12px" }}>描述</span>
            <div style={{ fontSize: "13px", marginTop: "2px" }}>{permission.description}</div>
          </div>
        )}
        {inputStr && (
          <div>
            <span style={{ color: "#8b949e", fontSize: "12px" }}>参数</span>
            <pre style={{
              background: "#0d1117",
              border: "1px solid #30363d",
              borderRadius: "6px",
              padding: "8px 12px",
              fontSize: "12px",
              color: "#e6edf3",
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
              maxHeight: "180px",
              overflowY: "auto",
              marginTop: "4px",
            }}>
              {inputStr}
            </pre>
          </div>
        )}
        <div style={{ color: "#6e7681", fontSize: "12px", marginTop: "12px" }}>
          {countdown} 秒后自动拒绝
        </div>
      </DialogContent>
      <DialogActions style={{ borderTop: "1px solid #30363d", padding: "12px 16px", gap: "8px" }}>
        <Button
          variant="outlined"
          color="error"
          onClick={() => onRespond(false, permission.request_id)}
          style={{ borderColor: "#f85149", color: "#f85149" }}
        >
          拒绝
        </Button>
        <Button
          variant="contained"
          onClick={() => onRespond(true, permission.request_id)}
          style={{ background: "#238636" }}
        >
          允许
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CCPermissionDialog;
